module.exports = __webpack_public_path__ + "img/content.c88fe112.svg";